import type { FaireReviewEntity } from "../../entity_types/review";

// Real per-product review for Viverano Organics' "Veggie Baby Bonnet Hat -
// 2 Colors (Organic Muslin)" (p_esqeu42cj5), read from GET
// /api/product-reviews/product/p_esqeu42cj5 — verbatim comment, real
// reviewer, real rating, real publish date.
export const review_vo3: FaireReviewEntity = {
  token: "review_vo3",
  type: "review",
  brandName: "Viverano Organics",
  brandToken: "b_7fghelgl",
  productToken: "p_esqeu42cj5",
  reviewType: "product",
  reviewerName: "Gina L.",
  reviewerLocation: "Bloomingdale, IL",
  stars: 5,
  reviewText:
    "What a great company! Your lines are timeless! So many compliments on every item I've ordered which has me placing another order with you very soon.",
  reviewDate: "Mar 13, 2023",
  meta: {
    source: "api",
    importedAt: "2026-08-13T18:00:00.000Z",
    importedBy: "entity-db-cli",
  },
};
